import type { App } from 'vue'
import { createOAuth, defaultOAuthFunctions } from 'vue-oidc'
import { registerComponents } from './components'
import { adminGuard, authorizedGuard, isNotAuthorizedGuard, loginGuard, logoutGuard, oauthCallbackGuard, signInFirst } from './guards'
import { expiringEarly } from './model'

export * from './store'
export { adminGuard, authorizedGuard, isNotAuthorizedGuard, loginGuard, logoutGuard, oauthCallbackGuard, signInFirst }

const nothing = { render: () => null }

export const createAuth = () => ({
  install: (app: App) => {
    registerComponents(app)

    app.use(
      createOAuth({
        // Whole literal reads only — a destructure is not substituted (`CLAUDE.md`).
        config: {
          issuerPath: process.env.OAUTH_ISSUER_PATH,
          clientId: process.env.OAUTH_CLIENT_ID,
          scope: process.env.OAUTH_SCOPE,
          pkce: process.env.OAUTH_PKCE && JSON.parse(process.env.OAUTH_PKCE)
        },
        functions: {
          ...expiringEarly(defaultOAuthFunctions),
          userInfo: async () => undefined
        }
      })
    )

    const router = app.getRouter()

    router.addRoute({
      path: '/login',
      name: 'login',
      component: nothing,
      beforeEnter: [isNotAuthorizedGuard, loginGuard]
    })

    router.addRoute({
      path: '/logout',
      name: 'logout',
      component: nothing,
      beforeEnter: logoutGuard
    })

    router.addRoute({
      path: '/callback',
      name: 'oauth-callback',
      component: nothing,
      beforeEnter: oauthCallbackGuard
    })
  }
})
